module.exports = __webpack_public_path__ + "static/media/box.373607a2.gif";